const UserRoles = {
  MEMBER: 'Company Member',
  ADMIN: 'Company Admin',
  OWNER: 'Company Owner',
} as const;

export type UserRole = (typeof UserRoles)[keyof typeof UserRoles];
export default UserRoles;
